import {
  Flex,
  Skeleton,
  Text,
} from '@mantine/core'

import { useTranslation } from '@flecto/translations'
import {  useMediaQuery } from '@flecto/ui'

import { DropdownFilters } from './DropdownFilters'
import { FilterSorter } from './FilterSorter'

export type ListHeaderControlsProps = {
  totalCount?: number
  isSearching?: boolean
  withCategoriesFilter?: boolean
}

export function ListHeaderControls({
  totalCount,
  isSearching,
  withCategoriesFilter = true,
}: ListHeaderControlsProps) {
  const { t } = useTranslation('store', {
    keyPrefix: 'store-page-product-list',
  })

  const { isDesktop } = useMediaQuery()

  return (
    <Flex justify='space-between' align='center' mb='md' mt={isDesktop ? 'lg' : 'xl'}>
      {!isDesktop ? (
        <DropdownFilters withCategories={withCategoriesFilter} />
      ) : (
        <Text size='sm' c='dimmed' mt='sm'>
          {isSearching ? (
            <Skeleton h={12} w={120} />
          ) : (
            t('label_results', { count: totalCount })
          )}
        </Text>
      )}
      <FilterSorter />
    </Flex>
  )
}
